export default __webpack_public_path__ + "static/media/food9.1684fc71.png";